import {
  GET_VENDOR_CHAUFFEURS,
  GET_VENDOR_CHAUFFEURS_SUCCESS,
  GET_VENDOR_CHAUFFEURS_ERROR,
  GET_VENDOR_CHAUFFEURS_EMPTY,
} from './../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetVendorChauffeurs = (state = initialState, action) => {
  switch (action.type) {
    case GET_VENDOR_CHAUFFEURS:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_VENDOR_CHAUFFEURS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_VENDOR_CHAUFFEURS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_VENDOR_CHAUFFEURS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetVendorChauffeurs;
